// Different page views for the WhenAndWhere component.
export const WhenAndWhereMobileView = Object.freeze({
  DEFAULT: 'DEFAULT',
  SEARCH_ADDRESS: 'SEARCH_ADDRESS'
});
